import { useTranslation } from 'react-i18next';
import { useLocale } from '../context/LocaleContext.js';

const LANGUAGES = [
  { code: 'id', label: 'Bahasa Indonesia' },
  { code: 'en', label: 'English' },
];

export function LanguageSwitcher() {
  const { t } = useTranslation();
  const { locale, setLocale } = useLocale();

  const activeLabel = LANGUAGES.find((l) => l.code === locale)?.label ?? 'Bahasa Indonesia';

  return (
    <div className="flex items-center gap-1.5">
      <span className="text-xs text-slate-500 font-medium">{t('languageSwitcher.label')}:</span>
      <select
        value={locale}
        onChange={(e) => setLocale(e.target.value)}
        className="bg-bone-soft border border-slate-200 focus:border-copper rounded px-2 py-1 text-xs text-ink font-medium outline-none cursor-pointer transition-colors duration-200"
        aria-label={t('languageSwitcher.label')}
        title={activeLabel}
      >
        {LANGUAGES.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.label}
          </option>
        ))}
      </select>
    </div>
  );
}
